import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RESULTPAGEMESSAGE } from '@common/constants';
import { IResultPageState } from '@common/models';
import { ResultPageService } from '@common/services';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from 'src/app/common.service';
import { NavigationService } from 'src/app/services/navigation/navigation.service';

@Component({
  selector: 'app-result-page',
  templateUrl: './result-page.component.html',
  styleUrls: ['./result-page.component.scss'],
})
export class ResultPageComponent implements OnInit {
  protected resultstate: Partial<IResultPageState> = {};
  isFavorite: boolean;
  currentFavInvNo: any;
  isAdd: boolean = true;

  constructor(
    private _router: Router,
    private _resultpageService: ResultPageService,
    private _navigationService: NavigationService,
    private translate: TranslateService,
    private _commonService: CommonService
  ) {
    this.resultstate = this._router.getCurrentNavigation()?.extras?.queryParams;
    if(this.resultstate.alertType === 'Success'){
      //this.resultstate.message = RESULTPAGEMESSAGE[this.resultstate.serviceCode];
      let resultMessage = this.translate.instant('RESULTPAGEMESSAGE.' + this.resultstate.serviceCode);

      if (this.resultstate.serviceCode == 'INTBTBENEADD' || this.resultstate.serviceCode == 'ACHBENEADD' || this.resultstate.serviceCode == 'SWIFTBENEADD') {
        this.isAdd = false;

      }
      else {
        this.isAdd = true;
      }

      if (this.resultstate.successMsgNumber) resultMessage = resultMessage.replace('successMsgNumber', this.resultstate.successMsgNumber);
      this.resultstate.message = resultMessage;
    };
    this._resultpageService.resetResultPageData();
  }

  ngOnInit(): void {
      this._commonService.hideSpinner();
  }

  resultButtonClickHandler(navDetails): void {
    try {
      this._router.navigate(navDetails.path, {
        queryParams: navDetails.state,
        queryParamsHandling: 'preserve',
      });
    } catch (err) {
      console.error(err);
    }
  }
  makeAsFavourite(resultstate) {
    if(this.isFavorite && this.currentFavInvNo) {
      this._resultpageService.makeUnFavoritePayment(this.currentFavInvNo).subscribe(
        (res)=>{
          this.isFavorite = !this.isFavorite;
          this.currentFavInvNo = res.favouritepayments.inventoryNo;
          console.log(res);
        }
      );
      return;
    }
    let payload = {};
    payload['favouritepayments'] =  {
      "tranInventoryNo": resultstate.resultPayload[Object.keys(resultstate.resultPayload)[0]].tranRefNo,
      "paymentSystem": resultstate.paymentData.paymentSystem,
      "beneId": resultstate.paymentData.beneId,
      "accNo": resultstate.paymentData.fromAccountNumber,
      "amount": resultstate.paymentData.paymentAmount,
      "currency": resultstate.paymentData.paymentCurrency,
      "remarks": resultstate.paymentData.remarks,
      }
    this._resultpageService.makeFavoritePayment(payload).subscribe(
      (res)=>{
        this.isFavorite = !this.isFavorite;
        this.currentFavInvNo = res.favouritepayments.inventoryNo;
        console.log(res);
      }
    );
    console.log(resultstate);
  }
}
